module.exports = __webpack_public_path__ + "static/img/research.f5100dce.jpg";